import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTada = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 498,
	height: 108,
	viewBox: "0 0 498 108",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M397.856 88.6987L384.489 102M397.856 102L384.489 88.6987M103.066 92.9594H86.4148M94.7414 101.243V84.6753M377.127 6L365.139 17.9289M377.127 17.929L365.139 6.00001M459.768 65.7761C458.049 68.1935 456.888 70.9506 456.552 73.9465C455.664 81.3027 459.758 88.4637 464.784 93.9613C466.968 96.4066 469.507 98.6572 472.553 99.9841C475.879 101.481 480.252 101.942 483.872 101.71C487.311 101.485 490.896 100.35 493.245 97.8178C495.769 95.0978 496.612 91.1781 496.918 87.4602C497.204 83.2008 496.757 78.7893 495.324 74.6876C493.993 70.8531 490.799 68.0858 488.054 65.2105C482.278 59.1096 473.105 56.5765 465.471 60.8526C463.068 62.0314 461.229 63.7303 459.768 65.7761ZM60.2063 20.5127C58.5878 16.9767 56.2139 13.8455 53.0222 11.4885C45.2287 5.62698 34.3662 5.51499 24.7831 7.55348C20.5549 8.40139 16.3139 9.77863 12.7898 12.339C8.8879 15.1017 5.47335 19.7304 3.34656 23.9674C1.33137 27.9954 0.256289 32.7884 1.58935 37.1117C3.02116 41.7553 6.92976 45.2954 10.9628 48.0972C15.6269 51.2324 20.9477 53.6426 26.5668 54.736C31.8145 55.7673 37.0772 53.9918 42.166 52.7946C52.9318 50.3089 61.8772 41.6341 62.0483 30.1981C62.2928 26.7085 61.5715 23.5127 60.2063 20.5127Z",
			stroke: "#ACD4FF",
			strokeWidth: 2,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_1662_35812)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M247.991 7.66622C247.446 5.80504 248.517 3.85601 250.389 3.34551C252.155 2.86349 254.001 3.8415 254.524 5.5966C257.886 16.8873 259.087 30.087 244.56 45.9995C243.277 47.4054 241.078 47.4078 239.732 46.0618C238.419 44.7483 238.398 42.6256 239.615 41.2215C252.364 26.5034 250.896 17.5796 247.991 7.66622Z",
					fill: "#ED8B00"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M301.713 48.5356C303.185 49.7113 303.172 51.8938 301.84 53.2259C300.528 54.5379 298.424 54.5278 296.919 53.4428C288.26 47.2003 277.75 49.5806 263.724 62.775C262.366 64.0523 260.226 64.0641 258.908 62.746C257.59 61.4278 257.589 59.282 258.95 58.0073C273.875 44.02 289.114 38.4724 301.713 48.5356Z",
					fill: "#9BD3DD"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M298.285 0.10619C299.76 -0.0209861 301.059 0.988785 301.448 2.41678C302.018 4.5043 300.445 6.46303 298.283 6.54086C295.734 6.63261 293.62 7.16818 291.243 9.54481C287.663 13.1246 290.05 15.5108 285.873 19.6871C281.697 23.8635 278.118 22.6705 274.538 26.2502C272.161 28.6268 271.626 30.7407 271.534 33.2897C271.456 35.452 269.497 37.0247 267.41 36.4553C265.982 36.0659 264.973 34.7675 265.1 33.2933C265.463 29.0762 266.789 24.4523 269.765 21.477C273.344 17.8973 277.521 18.4939 281.1 14.9142C284.68 11.3344 282.889 8.34949 286.469 4.77081C289.445 1.79659 294.068 0.469863 298.285 0.10619Z",
					fill: "#CD4C08"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M229.555 9.68652C229.555 7.82256 231.066 6.31152 232.93 6.31152C234.794 6.31152 236.305 7.82256 236.305 9.68652C236.305 11.5505 234.794 13.0615 232.93 13.0615C231.066 13.0615 229.555 11.5505 229.555 9.68652Z",
					fill: "#9BD3DD"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M235.422 23.1865C235.422 21.3226 236.933 19.8115 238.797 19.8115C240.661 19.8115 242.172 21.3226 242.172 23.1865C242.172 25.0505 240.661 26.5615 238.797 26.5615C236.933 26.5615 235.422 25.0505 235.422 23.1865Z",
					fill: "#9BD3DD"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M267.484 4.62402C267.484 2.76006 268.995 1.24902 270.859 1.24902C272.723 1.24902 274.234 2.76006 274.234 4.62402C274.234 6.48798 272.723 7.99902 270.859 7.99902C268.995 7.99902 267.484 6.48798 267.484 4.62402Z",
					fill: "#ED8B00"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M292.797 29.9365C292.797 28.0726 294.308 26.5615 296.172 26.5615C298.036 26.5615 299.547 28.0726 299.547 29.9365C299.547 31.8005 298.036 33.3115 296.172 33.3115C294.308 33.3115 292.797 31.8005 292.797 29.9365Z",
					fill: "#9BD3DD"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M280.984 61.999C280.984 60.1351 282.495 58.624 284.359 58.624C286.223 58.624 287.734 60.1351 287.734 61.999C287.734 63.863 286.223 65.374 284.359 65.374C282.495 65.374 280.984 63.863 280.984 61.999Z",
					fill: "#ED8B00"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M286.93 75.499C286.93 73.6351 288.441 72.124 290.305 72.124C292.169 72.124 293.68 73.6351 293.68 75.499C293.68 77.363 292.169 78.874 290.305 78.874C288.441 78.874 286.93 77.363 286.93 75.499Z",
					fill: "#ED8B00"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M226.791 33.0554C227.678 30.7889 230.599 30.1777 232.32 31.8988L272.273 71.8508C273.994 73.5718 273.382 76.4933 271.116 77.3802L205.48 103.064C202.74 104.136 200.035 101.432 201.108 98.6909L226.791 33.0554Z",
					fill: "#FDDA24"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M219.18 52.5076L221.795 45.8252L258.94 82.1443L251.664 84.992L219.18 52.5076Z",
					fill: "#ED8B00"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M211.348 72.5197L213.993 65.7598L238.807 90.0225L231.65 92.8224L211.348 72.5197Z",
					fill: "#ED8B00"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M269.25 78.1101L226.061 34.9206L226.791 33.0551C227.677 30.7892 230.599 30.1778 232.32 31.8983L272.272 71.8512C273.993 73.5716 273.382 76.4934 271.115 77.38L269.25 78.1101Z",
					fill: "#EAAA00"
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_1662_35812",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 108,
				height: 108,
				fill: "white",
				transform: "translate(195)"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgTada);
export default ForwardRef;
